<div class="surface-ground min-h-screen w-full pt-5 pb-5">
      
      <div class="container_width mx-auto px-3">
        
        <div class="grid">
          
          <div class="col-12 md:col-3">
            <div class="surface-card p-3 shadow-1 border-1 border-round h-full" style="border-color: #8383833b;">
              <div class="text-xl font-bold text-900 mb-4 px-2">Integrations</div>
              
              <div class="flex flex-column gap-2">
                @for (item of integrationTypes; track item.id) {
                  <div 
                    pRipple
                    (click)="selectedIntegration.set(item.id)"
                    class="flex align-items-center p-3 border-round cursor-pointer transition-colors transition-duration-150"
                    [class.bg-red-50]="selectedIntegration() === item.id && item.id === 'youtube'"
                    [class.text-red-600]="selectedIntegration() === item.id && item.id === 'youtube'"
                    [class.surface-hover]="selectedIntegration() !== item.id"
                    [class.text-700]="selectedIntegration() !== item.id">
                    
                    <i [class]="item.icon + ' mr-3 text-xl'"></i>
                    <span class="font-medium">{{ item.name }}</span>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="col-12 md:col-9">
              @switch (selectedIntegration()) {
                @case ('youtube') {
                  <app-youtube-integration class="w-full"></app-youtube-integration>
                }
              }
          </div>

        </div>
      </div>
      
    </div>